import { Link } from 'react-router-dom';
import { categories } from '@/mocks/categories';

export default function CategorySection() {
  return (
    <section className="w-full py-16 md:py-20 bg-background-100/60">
      <div className="w-full px-4 md:px-6">
        <div className="text-center mb-12">
          <h2 className="text-2xl md:text-3xl font-heading font-bold text-foreground-900 mb-3">
            探索内容分类
          </h2>
          <p className="text-sm text-foreground-600 max-w-xl mx-auto">
            按主题浏览爱液网页版的使用指南、技巧教程和最新动态，找到你最需要的内容
          </p>
        </div>

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-5 max-w-6xl mx-auto">
          {categories.map((category) => (
            <Link
              key={category.slug}
              to={`/category/${category.slug}`}
              className="group p-6 rounded-xl bg-background-50 border border-background-200/60 hover:border-accent-200 transition-all duration-300 hover:-translate-y-1 cursor-pointer"
            >
              <div className="flex items-start gap-4">
                <div className="w-12 h-12 rounded-xl bg-accent-100 flex items-center justify-center flex-shrink-0 group-hover:bg-accent-200 transition-colors duration-300">
                  <i className={`${category.icon} text-xl text-accent-600`}></i>
                </div>
                <div className="flex-1 min-w-0">
                  <h3 className="text-base font-semibold text-foreground-900 mb-1.5 group-hover:text-accent-700 transition-colors">
                    {category.name}
                  </h3>
                  <p className="text-sm text-foreground-600 leading-relaxed line-clamp-2 mb-3">
                    {category.description}
                  </p>
                  <span className="inline-flex items-center gap-1 text-xs text-accent-600 font-medium">
                    {category.count} 篇文章
                    <i className="ri-arrow-right-line text-xs"></i>
                  </span>
                </div>
              </div>
            </Link>
          ))}
        </div>
      </div>
    </section>
  );
}